import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

//Data
import data from "../../json/socialMedia.json";

//Styles
import "./FooterPropDevs.css";

const FooterPropDevs = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-container">
      <div className="footer-info-container">
        <div className="footer-about-us">
          <h3>{t("footer.title_1")}</h3>
          <p>{t("footer.info.info_1")}</p>
        </div>
        <div className="social-media-footer">
          <h3>{t("footer.title_5")}</h3>
          <div className="social-media-container">
            {data.data.map((sm, i) => {
              return (
                <a
                  key={i}
                  className="anchor-sm"
                  href={sm.href}
                  title={sm.title}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="social-media"
                    onMouseOver={(e) => (e.target.src = sm.hover)}
                    onMouseLeave={(e) => (e.target.src = sm.src)}
                    src={sm.src}
                    alt={sm.alt}
                  />
                </a>
              );
            })}
          </div>
        </div>
      </div>
      <div className="footer-info-container">
        <h3>{t("footer.title_2")}</h3>
        <p>
          Calle 52A No. 31 - 140, Cabecera, Bucaramanga, Santander - Colombia
        </p>
        <p>PBX: +57 (7) 6435677</p>
        <p>FAX: +57 (7) 6472253</p>
        <p>{t("footer.info.info_2")}</p>
      </div>
      <div className="footer-info-container">
        <h3>{t("footer.title_3")}</h3>
        <a
          className="doc-anchor"
          href="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/docs/FI-067+POLITICA+DE+TRATAMIENTO+DE+LA+INFORMACI%C3%93N+OTACC+S.A..pdf"
          target="_blank"
          title="Politica de Protección de Datos Personales"
          rel="noreferrer"
        >
          {t("footer.info.info_3")}
        </a>
        <a
          className="doc-anchor"
          href="/ofertas-de-empleo"
          title="Ofertas de empleo"
        >
          {t("footer.info.info_4")}
        </a>
      </div>
      <div className="footer-info-container">
        <h3>{t("footer.title_4")}</h3>
        <div className="foundation-btn-container">
          <Link
            className="anchor-foundation"
            to="/fundacion-otacc"
            title="Fundación OTACC"
          >
            <div className="text-btn-container">{t("footer.info.info_5")}</div>
            <div className="separation-line-btn"></div>
            <div className="icon-btn-container">
              <img
                className="btn-icon"
                src="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/btn-foundation-icon.webp"
                alt=""
              />
            </div>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default FooterPropDevs;
